export default {
      id: "input-usage",
      viewBox: "0 0 35 34",
      url: __webpack_public_path__ + "img/icons.svg#input",
      toString: function () {
        return this.url;
      }
    }